import { createContext, useCallback, useContext, useState } from 'react';

/**
 * Context to manage page navigation and currentStep resets.
 * When a user navigates to the same page via menu, this context triggers
 * a reset signal that pages can listen to.
 */
const PageNavigationContext = createContext({
  navigationKey: 0,
  triggerReset: () => { },
});

/**
 * Provider component that wraps the application.
 */
export function PageNavigationProvider({ children }) {
  const [navigationKey, setNavigationKey] = useState(0);

  const triggerReset = useCallback(() => {
    setNavigationKey((prev) => prev + 1);
  }, []);

  return (
    <PageNavigationContext.Provider value={{ navigationKey, triggerReset }}>
      {children}
    </PageNavigationContext.Provider>
  );
}

/**
 * Hook to access the navigation context.
 * @returns {{ navigationKey: number, triggerReset: () => void }}
 */
export function usePageNavigation() {
  const context = useContext(PageNavigationContext);
  if (!context) {
    throw new Error('usePageNavigation must be used within a PageNavigationProvider');
  }
  return context;
}
